module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c((!_vm.is_relative && !_vm.ispreview) ? 'drag-resizable' : 'div', {
    tag: "div",
    staticClass: "cstlayer",
    class: {
      'mod_wrapper': _vm.iswrapper
    },
    style: ([_vm.modStyle(_vm.mod_param.globalstyle), {
      'box-sizing': (_vm.type == 'media') ? 'content-box' : 'border-box',
      left: _vm.is_relative ? false : ((_vm.pos.left) + "px"),
      top: _vm.is_relative ? false : ((_vm.pos.top) + "px"),
      width: _vm.is_relative ? false : ((_vm.size.width) + "px"),
      height: (_vm.type == 'webpage') ? '100%' : ((_vm.size.height == 'auto') ? _vm.size.height : ((_vm.size.height) + "px")),
      'z-index': _vm.is_relative ? false : _vm.pos.zindex
    }]),
    attrs: {
      "id": _vm.id,
      "x": _vm.pos.left,
      "y": _vm.pos.top,
      "w": _vm.size.width,
      "h": _vm._f("calcheight")(_vm.size.height, _vm.is_relative ? '' : _vm.id),
      "type": _vm.type,
      "parent": true
    },
    on: {
      "dragging": _vm.onDrag,
      "resizing": _vm.onResize,
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onActivated($event)
      },
      "activated": _vm.onActivated,
      "deactivated": _vm.onDeactivated
    }
  }, [(!_vm.ispreview) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "handler handler-top"
  }) : _vm._e(), _vm._v(" "), (!_vm.ispreview) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "handler handler-btm"
  }, [(_vm.heightResizable && _vm.isActive && _vm.is_active) ? _c('span', {
    staticClass: "btmhandler",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.layoutResize('bm', $event)
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.is_relative && !_vm.ispreview) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "handler handler-right"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_active),
      expression: "is_active"
    }],
    staticClass: "handler handler-left"
  })] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wp_content",
    style: ({
      'text-align': _vm.mod_param.childprop['text-align'] || 'left',
      width: _vm.is_relative ? '100%' : ((_vm.size.width) + "px"),
      height: _vm.is_relative ? '100%' : ((_vm.size.height) + "px")
    }),
    on: {
      "click": function($event) {
        _vm.layerTap(_vm.mod_param.childprop)
      }
    }
  }, [_c(("wp_" + _vm.type), {
    tag: "component",
    class: {
      'last-placeholder': _vm.islast && _vm.isContainer
    },
    attrs: {
      "param": _vm.mod_param.childprop,
      "children": _vm.children,
      "comp_id": _vm.mod_param.id,
      "isactive": _vm.is_active
    }
  })], 1), _vm._v(" "), (_vm.position == 'relative' && !_vm.ispreview) ? [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "myhandler"
  }, [_vm._v("Ξ")])] : _vm._e(), _vm._v(" "), (!_vm.ispreview) ? _c('div', {
    staticClass: "removit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.rmPlugin($event)
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (!_vm.isContainer && !_vm.ispreview) ? _c('div', {
    staticClass: "masklayer"
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0c6556f5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/module.vue
// module id = 183
// module chunks = 2